var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/video-player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 5.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,0.75 L21.75,0.75 C22.5784271,0.75 23.25,1.42157288 23.25,2.25 L23.25,19.75 C23.25,20.5784271 22.5784271,21.25 21.75,21.25 L2.25,21.25 C1.42157288,21.25 0.75,20.5784271 0.75,19.75 L0.75,2.25 C0.75,1.42157288 1.42157288,0.75 2.25,0.75 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.238,14.66 C9.97265972,14.7923174 9.65774233,14.7778997 9.4056024,14.6218906 C9.15346246,14.4658816 9,14.1905019 9,13.894 L9,8.106 C9,7.80949812 9.15346246,7.5341184 9.4056024,7.37810936 C9.65774233,7.22210032 9.97265972,7.20768257 10.238,7.34 L16.027,10.235 C16.3169516,10.3797247 16.5001623,10.6759365 16.5001623,11 C16.5001623,11.3240635 16.3169516,11.6202753 16.027,11.765 L10.238,14.66 Z",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.e6746987f8d71772a5ddc3b24a6292ab.svg";
export { ForwardRef as ReactComponent };